// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react'; import I18n from 'i18n-js';

import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCAccordion } from '@reverbdotcom/cadence/components';
import URLHelpers from './shared/url_helpers';
import {
  Item2ShopReturnPoliciesData,
} from '@reverbdotcom/commons/src/gql/graphql';

interface IProps {
  listing: Item2ShopReturnPoliciesData.Fragment;
}

export const Item2ShopReturnPoliciesFragment = gql`
  fragment Item2ShopReturnPoliciesData on Listing {
    _id
    id
    acceptedPaymentMethods
    condition {
      conditionSlug
    }
    estimatedMonthlyPaymentPlan {
      estimatedMonthlyPayment {
        display
      }
      maxTermMonth
    }
    shop {
      _id
      userUuid
      returnPolicy {
        newReturnWindowDays
        usedReturnWindowDays
        restockingFeePercent
        specialConditions
        legacyReturnPolicyText
      }
    }
    soldAsIs
  }
`;

interface IReturnPolicySectionProps {
  heading: string;
  children: any;
}

function ReturnPolicySection(props: IReturnPolicySectionProps) {
  return (
    <>
      <h4 className="weight-bold mb-2">{props.heading}</h4>
      {props.children}
    </>
  );
}

export default class ListingReturnPolicies extends React.Component<IProps, null> {
  getMessageUrl() {
    return URLHelpers.newDashboardMessagesPath(
      this.props.listing.id,
      this.props.listing.shop.userUuid,
    );
  }

  renderReturnWindowText() {
    const { condition } = this.props.listing;
    const { usedReturnWindowDays, newReturnWindowDays } = this.props.listing.shop.returnPolicy;

    if (condition.conditionSlug === 'brand-new') {
      return I18n.t('discovery.listingReturnPolicies.returnWindowDescription', { days: newReturnWindowDays });
    }
    return I18n.t('discovery.listingReturnPolicies.returnWindowDescription', { days: usedReturnWindowDays });
  }

  renderRefundText() {
    const { restockingFeePercent } = this.props.listing.shop.returnPolicy;

    if (restockingFeePercent !== 0) {
      return I18n.t('discovery.shopReturnPolicies.refundTextWithRestockingFee', { restockingFee: restockingFeePercent });
    }
    return I18n.t('discovery.shopReturnPolicies.refundTextWithoutRestockingFee');
  }

  renderSpecialConditions() {
    const { shop } = this.props.listing;
    if (!shop.returnPolicy.specialConditions) { return null; }

    return (
      <ReturnPolicySection
        heading={I18n.t('discovery.shopReturnPolicies.specialConditions')}
      >
        <SanitizedRender
          html={shop.returnPolicy.specialConditions}
          htmlTag="p"
          convertNewlines
          truncationLimit={300}
        />
      </ReturnPolicySection>
    );
  }

  renderAffirmReturnPolicy() {
    const { acceptedPaymentMethods, estimatedMonthlyPaymentPlan } = this.props.listing;
    if (!acceptedPaymentMethods.includes('affirm') || !estimatedMonthlyPaymentPlan.estimatedMonthlyPayment) { return null; }

    return (
      <ReturnPolicySection
        heading={I18n.t('discovery.listingReturnPolicies.refundsAffirmHeader')}
      >
        <div data-affirm-return-policy>
          <SanitizedRender
            html={I18n.t('discovery.listingReturnPolicies.affirmReturnPolicy', {
              linkStart: `<a href="${URLHelpers.cmsPagePath('affirm-faqs')}" target="_blank">`,
              linkEnd: '</a>',
            })}
            htmlTag="p"
          />
        </div>
      </ReturnPolicySection>
    );
  }

  render() {
    const { soldAsIs } = this.props.listing;

    if (soldAsIs) {
      return (
        <p className="size-90 mb-0">
          {I18n.t('discovery.item2Description.asDescribed.body')}
        </p>
      );
    }

    if (!this.props.listing.shop.returnPolicy) {
      return (
        <ReturnPolicySection
          heading={I18n.t('discovery.listingReturnPolicies.returnPolicyNotSet')}
        >
          <div className="size-90" data-return-policy-not-set>
            <a href={this.getMessageUrl()}>
              {I18n.t('discovery.listingReturnPolicies.contactSeller')}
            </a>
            {this.renderAffirmReturnPolicy()}
          </div>
        </ReturnPolicySection>
      );
    }

    if (this.props.listing.shop.returnPolicy.legacyReturnPolicyText !== '') {
      return (
        <div className="size-90">
          <p data-legacy-shop-return-text>
            {this.props.listing.shop.returnPolicy.legacyReturnPolicyText}
          </p>

          {this.renderAffirmReturnPolicy()}
        </div>
      );
    }

    return (
      <>
        <div
          data-return-window
          className="size-90 mb-2"
        >
          {this.renderReturnWindowText()}
        </div>
        <div
          className="bdt-1 bdb-1 bd-primary"
        >
          <RCAccordion
            heading={I18n.t('discovery.listingReturnPolicies.viewAll')}
            size="small"
            id="listing-return-policies"
          >
            <ReturnPolicySection
              heading={I18n.t('discovery.shopReturnPolicies.generalTerms')}
            >
              <p data-general-terms>
                {I18n.t('discovery.shopReturnPolicies.generalTermsDescription')}
              </p>
            </ReturnPolicySection>
            <ReturnPolicySection
              heading={I18n.t('discovery.listingReturnPolicies.refundsHeader')}
            >
              <p data-refunds>
                {this.renderRefundText()}
              </p>
            </ReturnPolicySection>
            {this.renderSpecialConditions()}
          </RCAccordion>
        </div>
      </>
    );
  }
}
